/* ============================================================
   LIVRARIA — Produtos vistos recentemente (localStorage)
   Registra o produto atual (window.LFCRecent.current) e
   renderiza nos elementos <recently-viewed>. Código original.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'lfc_recently_viewed';
  var MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function track() {
    var cur = window.LFCRecent && window.LFCRecent.current;
    if (!cur || !cur.handle) return;
    var list = read().filter(function (p) { return p.handle !== cur.handle; });
    list.unshift(cur);
    write(list.slice(0, MAX));
  }

  function render() {
    var hosts = document.querySelectorAll('recently-viewed');
    var list = read();
    hosts.forEach(function (host) {
      var grid = host.querySelector('[data-recent-grid]');
      if (!grid) return;
      var exclude = host.getAttribute('data-exclude') || '';
      var limit = parseInt(host.getAttribute('data-limit'), 10) || 4;
      var items = list.filter(function (p) { return p.handle !== exclude; }).slice(0, limit);
      if (!items.length) { host.style.display = 'none'; return; }
      grid.innerHTML = items.map(function (p) {
        return (
          '<li class="rv__item">' +
            '<a class="rv__link" href="' + p.url + '">' +
              '<span class="rv__media premium-figure is-visible">' +
                (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
              '</span>' +
              '<span class="rv__title">' + p.title + '</span>' +
              '<span class="rv__price">' + (p.price || '') + '</span>' +
            '</a>' +
          '</li>'
        );
      }).join('');
      host.style.display = '';
    });
  }

  function init() { track(); render(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
